
page.checklist.News = {
    enabled: false,
    ready: false,
    needsLoad: false,
    progress: 0,
    check: function(){ // Šitą funkciją vykdo kai tikrina užkrauto puslapio DOM, ieško elementų
        this.reset();
        if(page.v.firstLoad) this.first(); // Pirmą kart užkrovus tinklapį galima susikurti kažkokius pastovius kintamuosius ir t.t.

        if($('.section-news').length > 0){ // jei randi reikiamą elementą - modulis įjungiamas.
            log.page("CHECK: News detected", 2);
            this.enabled = true;
        }
    },
    reset: function(){
        this.enabled = false;
        this.ready = false;
        this.needsLoad = false;
        this.progress = 0;
    },
    init: function(){ // Ši funkcija vykdoma iškart po DOM apdorojimo, galima kabint eventus ir t.t.
        let name = $('.barba-container').data('namespace');
        page.transitions(name, 900);
        page.main.fr.altMenu.alt();
        page.main.fr.floatLabels.init();
        page.popupforms.init();


    /*    $('.news-item img').fancybox({
            src  : $(this).attr('src'),
            // Options will go here
        });*/


        /*$('.ss-triger').click(function(e){
            e.preventDefault();
            $('.subscriber-settings').addClass('active');


        });
*/
        this.resize();

        document.querySelectorAll('.btn-show-password').forEach(elPass => {
            elPass.addEventListener('click', () => {
                elPass.parentNode.classList.toggle('show');
                const input = elPass.parentNode.querySelector('input');
                input.type = input.type == 'password' ? 'text' : 'password';
            });
        });
    },
    first: function(){ // Ši funkcija vykdoma pirmą kartą užkrovus tinklapį

    },
    unload: function(){ // Ši funkcija skirta išvalyti eventams prieš nukraunant puslapį per ajax.
        page.popupforms.destroy();
        page.main.fr.floatLabels.destroy();
    },
    calc: function(){ // Ši funkcija vykdoma kiekvieno kadro metu (animacijoms ir t.t.)

    },
    resize: function(){ // onResize funkcija (pati administruojasi, nereikia atrišinėti)

    },
    scroll: function(){ // onScroll funkcija (pati administruojasi)

    },
    v: {
        // Jei reikalingi vidiniai kintamieji programos darbui, kurie turi išlikti tarp funkcijų vydymo
    },
    f: {
        // Jei reikalingos papildomos vidinės funkcijos modulio veikimui
    }
}